__turbopack_context__.v({
  "enter": "KGjH2q_enter",
  "main": "KGjH2q_main",
});
